<template>
  <section
    id="cover"
    class="te-bg-android-jobs-image flex h-[270px] flex-col items-center justify-center bg-cover bg-center px-4 text-center text-white"
  >
    <h1 class="te-title-mentor-recruits mb-5 font-bold drop-shadow-[0_1px_2px_rgba(0,0,0,.3)]">
      Androidアプリメンター<br class="lg:hidden">（講師）の募集
    </h1>
  </section>
</template>

<style scoped>
.te-bg-android-jobs-image {
  background-image: url('~/assets/images/Te/TeJob/Android/Cover/cover-mentor-android.jpg');
}

/* // メンター募集ページ用タイトル */
.te-title-mentor-recruits {
  font-size: 1.25rem;
  @media (min-width: 768px) {
    font-size: 2.25rem;
  }
}
</style>
